import React, { Component, Fragment, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import OpinionTypes from './filters/opinion-types';
import Jurisdictions from './filters/jurisdictions';
import OpinionStatus from './filters/opinion-status';
import SearchForm from './filters/search-form';
class OpinionsSideBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  expandedSections: {}, 
		  isMobile: false, 
		  showSideBar: false,

		};
	
		// Bind methods to this
		this.toggleSection = this.toggleSection.bind(this);
		this.getSearch = this.getSearch.bind(this);
		this.handleMobileSidebarToggle = this.handleMobileSidebarToggle.bind(this);
		// this.book_document_types = getBookStoreObj().book_document_types;
	  }
	

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}




	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
	  
		// Add event listeners to the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll('#mobile-sidebar-options, .btn-show-categories');
		mobileSidebarButtons.forEach(button => {
		  button.addEventListener('click', this.handleMobileSidebarToggle);
		});
		//For scroll 
		this.handleScroll = this.handleScroll.bind(this);
		window.addEventListener('scroll', this.handleScroll);
		this.sidebarRef = React.createRef();
		this.handleScroll();
	  }

	  componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize.bind(this));
	  
		// Remove event listeners from the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll('#mobile-sidebar-options, .btn-show-categories');
		mobileSidebarButtons.forEach(button => {
		  button.removeEventListener('click', this.handleMobileSidebarToggle);
		});
		window.removeEventListener('scroll', this.handleScroll);

	  }

	  handleMobileSidebarToggle() {
		this.setState(prevState => ({
		  showSideBar: !prevState.showSideBar
		}), () => {
		  if (this.state.showSideBar && this.sidebarRef.current) {
			this.sidebarRef.current.style.bottom = 'auto';
			this.sidebarRef.current.style.top = '0';
		  }
		});
	  }

	  handleScroll() {
		const sidebar = this.sidebarRef.current;
		const footer = document.querySelector('.site-footer');
		const loginBlock = document.querySelector('.login-block-common');
		if (!sidebar || !footer) return;
	
		const sidebarRect = sidebar.getBoundingClientRect();
		const footerRect = footer.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		if (loginBlock && window.getComputedStyle(loginBlock).display === 'block') {
		  sidebar.style.bottom = 'auto';
		} else if (footerRect.top <= windowHeight) {
		  const overlap = windowHeight - footerRect.top;
		  sidebar.style.bottom = `${overlap}px`;
		  sidebar.style.top = 'auto';
		} else {
		  sidebar.style.position = 'fixed';
		  sidebar.style.top = 'initial';
		  sidebar.style.bottom = 'auto';
		}
		if (this.state.showSideBar) {
			sidebar.style.bottom = 'auto';
			sidebar.style.top = 0;
		}
	  }

	toggleSection(index) {
		this.setState(function(prevState) {
			return {
				expandedSections: {
					...prevState.expandedSections,
					[index]: !prevState.expandedSections[index]
				}
			};
		});
	}

	getSearch() {
		return (<div>
				<hr className={ 'section-divider' }/>
				<div className={ 'sidebar-heading-container' }>
					<h3 className="sidebar-heading">Find on Page</h3>
				</div>
				<form class="form-inline" id="bookstore-find-on-page">
					<div class="side-bar-form-group">
						<label for="find-on-page" class="control-label">Find on page:</label>
						<input id="find-on-page" type="text" class="sidebar-input"/>
						<span id="bookstore-find-on-page-results"></span>
						<button role="submit" id="btn-find-catalog-text" className="sidebar-button">Search</button>
						{/* <span class="help-block">
							After starting a search, hit "Enter" to jump to the next search-term match.<br/>
							As an alternative, use the Ctrl + F keys to view all matches on this page.
						</span> */}
					</div>
				</form>
				{/* <input
					type="text"
					id="search"
					name="search"
					className="search-input"
					placeholder="Filter by keyword"
					value={ this.state.searchTerm }
					onChange={ this.handleSearchChange }
				/> */}
			</div>
		);
	}

	getOpinionTypes(){
		return (
			<Fragment>
				<hr className="section-divider"/>
				<OpinionTypes isMobile={this.state.isMobile} handleMobileSidebarToggle={this.handleMobileSidebarToggle}/>
			</Fragment>
		);
	}

	getJurisdictions(){
		return (
			<Fragment>
				<hr className="section-divider"/>
				<Jurisdictions />
			</Fragment>
		);
	}

	getOpinionStatus(){
		return (
			<Fragment>
				<hr className="section-divider"/>
				{/*<OpinionStatus />*/}
			</Fragment>
		);
	}

	getSearch(){
		return (
			<Fragment>
				<SearchForm />
			</Fragment>
		);
	}

	render() {
		return (
			<div className={`col-lg-3 side-bar side-bar-container ${this.state.showSideBar ? 'active' : ''}`} ref={this.sidebarRef}>
				<div className="side-bar-desktop">

					{this.getSearch()}
					{this.getOpinionTypes()}
					{this.getJurisdictions()}
					{this.getOpinionStatus()}
					{/* {this.renderDocumentTypes()} */}
					
				</div>
				{this.state.showSideBar && (
					<button className="done-button" onClick={() => {
						this.handleMobileSidebarToggle();
						this.props.toggleFilters();
					}}>Done</button>
				)}
			</div>
		);
	}

}

function mapStateToProps( { opinionTypes } ) {
	return {
		opinionTypes
	};
};

export default  connect(mapStateToProps, {  })(OpinionsSideBar);
